import React, { useState } from "react"
import Modal from "./modal"
import { usePageMessageBrokerListener } from "./use_page_message_broker_listener";

export default function SourceAttributionModalButton({url}) {
  const [show, setShow] = useState(false)
  const [pageObjectChanged, setPageObjectChanged] = useState(false)

  const handleClose = () => {
    setShow(false)
    if (pageObjectChanged) {
      window.location.reload()
    }
  }

  usePageMessageBrokerListener('fieldValueSaved', (data) => {
    if (show && url) {
      setPageObjectChanged(true)
    }
  });

  return (
    <>
      <button onClick={() => setShow(true)} className="link">Source</button>

      <Modal
        open={show}
        onClose={handleClose}
        url={url}
      />
    </>
  )
}
